import { useEffect, useState } from 'react';
import { APP_WRAPPER_ID } from 'utils/constants';

interface ScrollEvent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any;
}

export function useContainerScroll(id = APP_WRAPPER_ID): number {
  const [scrollDistance, setScrollDistance] = useState(0);

  useEffect(() => {
    const wrapper = document.getElementById(id);

    const listener = ({ target }: ScrollEvent): void => {
      if (target) setScrollDistance(target.scrollTop);
    };

    wrapper?.addEventListener('scroll', listener);

    return () => {
      wrapper?.removeEventListener('scroll', listener);
    };
  }, [id]);

  return scrollDistance;
}
